<div [formGroup]="parentForm">
  <div class="da-card">
    <h3 class="card-title">Awards &amp; Accolades</h3>
    
    <div class="form-grid align-center mb-24">
      <div class="field-group" style="grid-column: span 1;">
        <label>Do you wish to share details about any awards / achievements? <span class="required">*</span></label>
      </div>
      <div class="text-right awards-toggle-error">
        <p-selectButton [options]="yesNoOptions" formControlName="hasAwards" optionLabel="label" optionValue="value"
          [class.ng-invalid]="isFieldInvalid(parentForm, 'hasAwards')"
          [class.ng-dirty]="isFieldInvalid(parentForm, 'hasAwards')"></p-selectButton>
          <app-field-error [control]="parentForm.get('hasAwards')" type="requiredOnly" fieldName="This selection" ></app-field-error>
       
      </div>
    </div>

    <div formArrayName="awards" *ngIf="parentForm.get('hasAwards')?.value">
      <div *ngFor="let aw of awards.controls; let i=index" [formGroupName]="i" class="aw-item">
        <div class="card-header-actions">
          <div class="title">Achievement</div>
          <div class="actions">
            <button pButton type="button" icon="pi pi-trash" class="p-button-danger p-button-text" style="color: #ef4444; background: transparent; border: none; font-size: 1.2rem; cursor: pointer;" (click)="removeAward(i)"></button>
          </div>
        </div>

        <div class="form-grid">
          <!-- Achievement Type: full width -->
          <div class="field-group" style="grid-column: span 2; width:100%;">
            <label>Select Achievement Type <span class="required">*</span></label>
            <p-dropdown
              formControlName="category"
              [options]="categoryOptions"
              appendTo="body"
              placeholder="e.g. Sports, Academic, Leadership..."
              [style]="{'width':'100%'}"
              [class.ng-invalid]="isFieldInvalid(aw, 'category')"
              [class.ng-dirty]="isFieldInvalid(aw, 'category')">
            </p-dropdown>
            <app-field-error [control]="aw.get('category')" type="requiredOnly" fieldName="Achievement Type"></app-field-error>
          </div>

          <ng-container *ngIf="aw.get('category')?.value !== null && aw.get('category')?.value !== undefined">

            <!-- Award Name: half width when there's a second field, else full width -->
            <div class="field-group" [style.grid-column]="hasSecondField(aw.get('category')?.value) ? 'span 1' : 'span 2'">
              <label>
                <span [ngSwitch]="aw.get('category')?.value">
                  <span *ngSwitchCase="1">Award Name</span>
                  <span *ngSwitchCase="2">Award Name</span>
                  <span *ngSwitchCase="3">Leadership Role / Award</span>
                  <span *ngSwitchCase="4">Activity / Award Name</span>
                  <span *ngSwitchCase="5">Competition Name</span>
                  <span *ngSwitchDefault>Award / Activity Name</span>
                </span>
                <span class="required">*</span>
              </label>
              <input pInputText formControlName="awardName" placeholder="Enter award/activity name"
                [class.ng-invalid]="isFieldInvalid(aw, 'awardName')"
                [class.ng-dirty]="isFieldInvalid(aw, 'awardName')" />
              <app-field-error [control]="aw.get('awardName')" type="alphanumericText" fieldName="This field"></app-field-error>
            </div>

            <!-- Second column fields (paired with Award Name) -->
            <div class="field-group" style="grid-column: span 1;" *ngIf="aw.get('category')?.value === 1">
              <label>Issuing Body <span class="required">*</span></label>
              <input pInputText formControlName="issuingBody" placeholder="e.g. Federation / Board name"
                [class.ng-invalid]="isFieldInvalid(aw, 'issuingBody')"
                [class.ng-dirty]="isFieldInvalid(aw, 'issuingBody')" />
              <app-field-error [control]="aw.get('issuingBody')" type="alphanumericText" fieldName="Issuing Body"></app-field-error>
            </div>
            <div class="field-group" style="grid-column: span 1;" *ngIf="aw.get('category')?.value === 4">
              <label>Organisation / Cause <span class="required">*</span></label>
              <input pInputText formControlName="organisation" placeholder="e.g. NGO Name or Cause"
                [class.ng-invalid]="isFieldInvalid(aw, 'organisation')"
                [class.ng-dirty]="isFieldInvalid(aw, 'organisation')" />
              <app-field-error [control]="aw.get('organisation')" type="alphanumericText" fieldName="Organisation"></app-field-error>
            </div>
            <div class="field-group" style="grid-column: span 1;" *ngIf="aw.get('category')?.value === 3">
              <label>Responsibility <span class="required">*</span></label>
              <input pInputText formControlName="responsibility" placeholder="e.g. Led a team of 50 students"
                [class.ng-invalid]="isFieldInvalid(aw, 'responsibility')"
                [class.ng-dirty]="isFieldInvalid(aw, 'responsibility')" />
              <app-field-error [control]="aw.get('responsibility')" type="description500" fieldName="Responsibility"></app-field-error>
            </div>

            <!-- Level: full width -->
            <div class="field-group" style="grid-column: span 2; width:100%;">
              <label>Level <span class="required">*</span></label>
              <p-dropdown
                formControlName="level"
                [options]="levelOptions"
                appendTo="body"
                placeholder="Select level"
                [style]="{'width':'100%'}"
                [class.ng-invalid]="isFieldInvalid(aw, 'level')"
                [class.ng-dirty]="isFieldInvalid(aw, 'level')">
              </p-dropdown>
              <app-field-error [control]="aw.get('level')" type="requiredOnly" fieldName="Level"></app-field-error>
            </div>

            <!-- Optional full-width fields by category -->
            <div class="field-group" style="grid-column: span 2;" *ngIf="aw.get('category')?.value === 4">
              <label>Impact <span class="required">*</span></label>
              <input pInputText formControlName="impact" placeholder="e.g. Helped 200+ students"
                [class.ng-invalid]="isFieldInvalid(aw, 'impact')"
                [class.ng-dirty]="isFieldInvalid(aw, 'impact')" />
              <app-field-error [control]="aw.get('impact')" type="description500" fieldName="Impact"></app-field-error>
            </div>
            <div class="field-group" style="grid-column: span 2;" *ngIf="aw.get('category')?.value === 3">
              <label>Key Achievements <span class="required">*</span></label>
              <input pInputText formControlName="keyAchievements" placeholder="e.g. Organised annual school fest"
                [class.ng-invalid]="isFieldInvalid(aw, 'keyAchievements')"
                [class.ng-dirty]="isFieldInvalid(aw, 'keyAchievements')" />
              <app-field-error [control]="aw.get('keyAchievements')" type="description500" fieldName="Key Achievements"></app-field-error>
            </div>
            <div class="field-group" style="grid-column: span 2;" *ngIf="aw.get('category')?.value === 6">
              <label>Please Specify <span class="required">*</span></label>
              <input pInputText formControlName="specify" placeholder="Describe the type of activity or award"
                [class.ng-invalid]="isFieldInvalid(aw, 'specify')"
                [class.ng-dirty]="isFieldInvalid(aw, 'specify')" />
              <app-field-error [control]="aw.get('specify')" type="requiredOnly" fieldName="This field"></app-field-error>
            </div>

            <!-- Description: full width -->
            <div class="field-group" style="grid-column: span 2;">
              <label>Describe Your Achievement <span class="required">*</span></label>
              <textarea pInputTextarea formControlName="description" rows="3" class="p-inputtextarea"
                placeholder="Tell us what you achieved, your role and the impact"
                [class.ng-invalid]="isFieldInvalid(aw, 'description')"
                [class.ng-dirty]="isFieldInvalid(aw, 'description')"></textarea>
              <app-field-error [control]="aw.get('description')" type="description500" fieldName="Description"></app-field-error>
            </div>

            <!-- Certificate Upload: full width -->
            <div class="field-group" style="grid-column: span 2;">
              <label>Upload Certificate / Evidence </label>
              <div class="file-upload-row mt-16" [class.has-file]="aw.get('fileUrl')?.value">
                <ng-container *ngIf="aw.get('fileUrl')?.value; else noAwFile">
                  <div class="uploaded-file-pill">
                    <img src="assets/doc-icon.png" class="doc-icon" alt="Document">
                    <div class="file-details">
                      <div class="file-name-row">
                        <span class="file-name" (click)="previewFile(aw.get('fileUrl')?.value, 'Achievement ' + (i+1) + ' Certificate')" title="Certificate">
                          Achievement_{{i+1}}_Certificate.pdf
                        </span>
                        <i class="pi pi-check-circle check-icon" style="color: #16a34a;"></i>
                      </div>
                      <div class="file-meta">Uploaded</div>
                    </div>
                    <input type="file" #awReplaceInput style="display:none" accept=".pdf,.doc,.docx" (change)="onFileSelected($event, i, awReplaceInput)">
                    <button type="button" class="replace-btn" title="Replace" (click)="awReplaceInput.click()">Replace</button>
                  </div>
                </ng-container>
                <ng-template #noAwFile>
                  <div class="uploaded-file-pill" style="opacity: 0.6;">
                    <img src="assets/doc-icon.png" class="doc-icon" alt="Document">
                    <div class="file-details">
                      <div class="file-name-row">
                        <span class="file-name" style="color: #9ca3af;">Achievement {{i+1}} Certificate — Not uploaded</span>
                      </div>
                      <div class="file-meta" style="color: #f97316;"><i class="pi pi-upload" style="font-size: 11px;"></i> No file yet</div>
                    </div>
                    <input type="file" #awUploadInput style="display:none" accept=".pdf,.doc,.docx" (change)="onFileSelected($event, i, awUploadInput)">
                    <button type="button" class="replace-btn" (click)="awUploadInput.click()">Upload</button>
                  </div>
                </ng-template>
              </div>
              <app-field-error [control]="aw.get('fileUrl')" type="requiredOnly" fieldName="Certificate/Evidence document"></app-field-error>
            </div>

          </ng-container>
        </div>



        <!-- Save / Update Button Container -->
        <div class="flex justify-content-end mt-3" style="display: flex; justify-content: flex-end; margin-top: 1rem;" *ngIf="aw.get('category')?.value !== null && aw.get('category')?.value !== undefined">
          <button pButton type="button" 
                  [label]="aw.get('id')?.value ? 'Update' : 'Save'"
                  icon="pi pi-check"
                  class="p-button-sm p-button-primary"
                  [loading]="isSavingMap[i]"
                  [disabled]="isSavingMap[i]"
                  style="background: #000086; color: white; border: none; border-radius: 8px; padding: 0.5rem 1.5rem; font-weight: 600; cursor: pointer; display: flex; align-items: center; gap: 0.5rem;"
                  (click)="saveAward(i)">
          </button>
        </div>
        <div class="unsaved-warning" *ngIf="aw.get('category')?.value !== null && aw.get('category')?.value !== undefined && aw.dirty">
          You have unsaved changes. Please click {{ aw.get('id')?.value ? 'Update' : 'Save' }} to continue.
        </div>

      </div>
      
    <div class="add-item-trigger" (click)="addAward()">
      <button class="btn-link">+ Add Another Achievement</button>
    </div>
  </div>

  <div class="flex justify-content-end mt-3" style="display: flex; justify-content: flex-end; margin-top: 1rem;" *ngIf="parentForm.get('hasAwards')?.value === false">
    <button pButton type="button" 
            [label]="hasNoAwardsRecordId ? 'Update' : 'Save'"
            icon="pi pi-check"
            class="p-button-sm p-button-primary"
            [loading]="isSavingNoAwards"
            [disabled]="isSavingNoAwards"
            style="background: #000086; color: white; border: none; border-radius: 8px; padding: 0.5rem 1.5rem; font-weight: 600; cursor: pointer; display: flex; align-items: center; gap: 0.5rem;"
            (click)="saveNoAwards()">
    </button>
  </div>
  <div class="unsaved-warning" *ngIf="parentForm.get('hasAwards')?.value === false && parentForm.get('hasAwards')?.dirty">
    You have unsaved changes. Please click {{ hasNoAwardsRecordId ? 'Update' : 'Save' }} to continue.
  </div>

  <p-toast></p-toast>

  <!-- Custom Delete Confirmation Dialog -->
  <p-dialog
    [(visible)]="showDeleteDialog"
    [modal]="true"
    [closable]="!isDeleting"
    [dismissableMask]="!isDeleting"
    [style]="{width: '450px'}"
    styleClass="custom-delete-dialog"
    header="Delete Confirmation">
    <div style="display:flex; align-items:center; gap:16px; justify-content:center; padding: 0.5rem 0;">
      <span style="background:#eef2ff; border-radius:50%; width:60px; height:60px; display:inline-flex; align-items:center; justify-content:center; flex-shrink:0;">
        <i class="pi pi-exclamation-triangle" style="font-size:28px; color:#0b0a66;"></i>
      </span>
      <span style="font-size:17px; font-weight:600; color:#000; line-height:1.5;">Are you sure you want to delete this achievement?</span>
    </div>
    <ng-template pTemplate="footer">
      <button pButton
        class="custom-confirm-no"
        label="No"
        icon="pi pi-times"
        (click)="cancelDelete()"
        [disabled]="isDeleting">
      </button>
      <button pButton
        class="custom-confirm-yes"
        [label]="isDeleting ? 'Deleting...' : 'Yes'"
        [icon]="isDeleting ? 'pi pi-spin pi-spinner' : 'pi pi-check'"
        (click)="confirmDelete()"
        [disabled]="isDeleting">
      </button>
    </ng-template>
  </p-dialog>
</div>
